import { createSlice } from "@reduxjs/toolkit";
import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";

const homeState = {
  homePageUI: null,
  homePageHistoryList: null,
  error: null,
  listLoading: false,
  actionsLoading: false,
  searchLoading: false,
  isRefresh: false,
};

export const homeSlice = createSlice({
  name: "home",
  initialState: homeState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = false;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = false;
      }
    },
    throwError: (state, action) => {
      state.error = action.payload.data.error;
    },
    startCall: (state, action) => {
      state.isRefresh = false;
      state.error = null;

      if (action.payload.callType === ReduxCallTypesConst.LIST) {
        state.listLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.ACTION) {
        state.actionsLoading = true;
      } else if (action.payload.callType === ReduxCallTypesConst.DETAIL) {
        state.searchLoading = true;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
    homePageUIFetched: (state, action) => {
      state.listLoading = false;
      state.homePageUI = action.payload.data ?? {};
    },
    homeHistoryFetched: (state, action) => {
      state.listLoading = false;
      state.homePageHistoryList = action.payload.data ?? {};
    },
    homePageMemberDataFetched: (state, action) => {
      state.listLoading = false;
      state.homePageMemberData = action.payload.data ?? {};
    },
    profileFetched: (state, action) => {
      state.listLoading = false;
      state.profile = action.payload.data ?? {};
    },
  },
});
